import request from '@/utils/request'

export default {
  /**
   * 获取当前设备详情
   */
  getMerchantDeviceDetail() {
    return request.get('/merchant-devices/detail')
  },

  /**
   * 获取当前设备绑定状态
   */
  getBindingStatus(params) {
    return request.get('/merchant-devices/binding/status', {
      params
    })
  },

  /**
   * 上报当前设备的app版本
   */
  reportVersion(data) {
    return request.put('/merchant-devices/report-version', data)
  }
}
